<script>
    export let uid;
</script>


<p>Your userID is { uid }</p>